import { render, staticRenderFns } from "./SemaphoreHistoric.vue?vue&type=template&id=179f89de&scoped=true&"
import script from "./SemaphoreHistoric.vue?vue&type=script&lang=js&"
export * from "./SemaphoreHistoric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179f89de",
  null
  
)

export default component.exports